import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ChaserDashboardState {
  selectedAgents: string[];
}

const initialState: ChaserDashboardState = {
  selectedAgents: [],
};

const chaserDashboardSlice = createSlice({
  name: "chaserDashboard",
  initialState,
  reducers: {
    setChaserSelectedAgents(state, action: PayloadAction<string[]>) {
      state.selectedAgents = action.payload;
    },
  },
});

export const { setChaserSelectedAgents } = chaserDashboardSlice.actions;
export default chaserDashboardSlice.reducer;
